<template>
  <nuttrema-layout-form-standard :edit="true" :saveError="_get(ProgramCopy, 'saveError')" theme="west-top">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData"
        :rules="rules">

        <section>
          <div class="section-title">{{ $t('label.use_template') }}</div>
          <div class="section-items">
            <program-diet-small-card
               class="is-in-section"
              :details="ProgramDetails">
            </program-diet-small-card>
          </div>
        </section>

        <section>
          <div class="section-title">{{ $t('label.program_copy') }}</div>
          <div class="section-items">
            <el-form-item :label="$t('label.program_copy_name')" prop="name">
              <el-col :span="24">
                <el-input v-model="formData.name"></el-input>
              </el-col>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <div class="footer-row">
        <el-button type="primary" size="small" :loading="isSaving" @click="submitForm">{{ $t('label.copy') }}</el-button>
        <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.cancel') }}</el-button>
      </div>
    </template>
  </nuttrema-layout-form-standard>
</template>

<script>
import { clone } from 'lodash';

import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';
import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

import ProgramDietSmallCard from 'components/ui/card/program-diet-small-card';

export default {
  name: 'form-make-copy-program',
  mixins: [FormStandardBehavior],
  props: {
    ProgramCopy: {
      required: true,
      default: null,
    },
    ProgramDetails: {
      required: true,
      default: null,
    },
  },
  components: {
    ProgramDietSmallCard,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {
        name: null,
      },
      rules: {
        name: [
          {
            required: true,
            trigger: 'blur',
            message: this.formatValidationMessage('validation.required', 'label.name', true),
          },
        ],
      },
    };
  },
  methods: {
    getFormData() {
      return clone(this.formData);
    },
  },
  created() {
    this.stateData = this.ProgramCopy;
    this.formRef = 'program-copy';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/make-copy/form-make-copy-program.vue